import urls from "../common/urls"
import { http } from "../common/post"

const AccountSource = {
  getInsurancePlans: () => http(urls.plans, 'GET'),
  getMarketplaceInsurancePlans: token => http(`${urls.marketplacePlans}?token=${token}`, 'GET'),
  updateUserInsurancePlan: (office, plan, plan_holder) => http(urls.update_plan_information, 'POST', { office, plan, plan_holder }),
  postUserInsurancePlan: (office, plan, plan_holder) => http(urls.plan_information, 'POST', { office, plan, plan_holder }),
  getProfiles: () => http(urls.profile, "GET"),
  updateProfile: (
    id,
    first_name,
    last_name,
    sex,
    isself,
    year,
    month,
    day,
    age,
    height_ft,
    height_in,
    weight,
    phone
  ) =>
    http(urls.profile + id, "POST", {
      first_name,
      last_name,
      sex,
      isself,
      year,
      month,
      day,
      age,
      height_ft,
      height_in,
      weight,
      phone,
    }),
  deleteAccount: reason => http(urls.deleteAccount, "POST", { reason }),
  getProfileQuestions: profile_id =>
    http(`${urls.getProfileQuestions}${profile_id}/`, "GET"),
  updateProfileQuestions: (user_profile_id, question_answers) =>
    http(urls.updateProfileQuestions, "POST", {
      user_profile_id,
      question_answers,
    }),
}

export default AccountSource



// WEBPACK FOOTER //
// ./assets/account/Source.js